module.exports = __webpack_public_path__ + "img/25_3.0310e793.png";